var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-12 mt-8"},[_c('h3',{staticClass:"text-xl font-medium mb-4"},[_vm._t("title")],2),_c('div',[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }